// tslint:disable: quotemark
export enum ReportTypeEnum {
	Region = 0,
	County = 1,
	Organization = 2,
	Site = 3
}

export namespace ReportTypeEnum {
	export function toDescription(val: ReportTypeEnum) {
		switch (val) {
			case 0:
				return "Region";
			case 1:
				return "County";
			case 2:
				return "Organization";
			case 3:
				return "Site";
		}
		return null;
	}
}
